'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    margin-top: 0;\n  '], ['\n    margin-top: 0;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _ProductPageIcons = require('pricing-pages-unified-ui/constants/ProductPageIcons');

var _ProductPageIcons2 = _interopRequireDefault(_ProductPageIcons);

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _ProductsAndPlansNavIds2 = _interopRequireDefault(_ProductsAndPlansNavIds);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HubTitle = _styledComponents2.default.div.withConfig({
  displayName: 'StandardProductPageTitle__HubTitle'
})(['color:#33475b;font-size:', ';font-weight:600;line-height:44px;text-align:center;margin:0 auto 10px;', ';'], function (_ref) {
  var size = _ref.size;
  return size === 'small' ? '26px' : '32px';
}, _responsiveBreakpoints2.default.tabletPortrait(_templateObject));

var StandardProductPageTitle = function StandardProductPageTitle(_ref2) {
  var hub = _ref2.hub,
      size = _ref2.size;
  return _react2.default.createElement(
    HubTitle,
    { size: size },
    _react2.default.createElement(_UIImage2.default, {
      className: 'display-inline m-right-3 m-bottom-2',
      src: _ProductPageIcons2.default[hub]
    }),
    _react2.default.createElement(_FormattedMessage2.default, {
      message: 'pricingPage.pages.products.tabs.' + hub + '.tabTitle'
    })
  );
};

StandardProductPageTitle.propTypes = {
  hub: _react.PropTypes.oneOf(Object.values(_ProductsAndPlansNavIds2.default || {})).isRequired,
  size: _react.PropTypes.oneOf(['default', 'small'])
};

StandardProductPageTitle.defaultProps = {
  size: 'default'
};

exports.default = StandardProductPageTitle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/StandardProductPageTitle.js
// module id = 253
// module chunks = 3 4